<div class="search-container" [ngClass]="{'search-container-open' : products?.length || showNoRecords}">
    <div class="search-input-container" [style.border]="(isHeaderBreakpoint && isCustom) ? '1px solid ' + customConfig.mainColor : 'none'"
  [style.borderRadius]="(isHeaderBreakpoint && isCustom) ? '25px' : '0'">
        <input #searchInput type="text" class="search-input-field"
            [placeholder]="'selling.search_here' | translate"
            [(ngModel)]="searchInputValue"
            (input)="onSearchInput()"
            contentEditable="true">
        @if (searchInputValue?.trim().length > 0) {
            <div class="cancel-search-btn" (click)="closeSearchResultsDropdown()">
                @if (isHeaderBreakpoint) {
                    <span class="x-icon" aria-hidden="true"></span>
                } @else {
                    <span>{{'selling.cancel' | translate}}</span>
                }
            </div>
        }
        @if (!searchInputValue || (searchInputValue && !isHeaderBreakpoint)) {
            @if(isCustom){
            
                 <div class="search-icon-btn" (click)="onSearchClick()">                
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M6.70964 12.2474C9.77021 12.2474 12.2513 9.76631 12.2513 6.70573C12.2513 3.64515 9.77021 1.16406 6.70964 1.16406C3.64906 1.16406 1.16797 3.64515 1.16797 6.70573C1.16797 9.76631 3.64906 12.2474 6.70964 12.2474Z" [attr.stroke]="!isHeaderBreakpoint ? defaultBurgerColor : customConfig.mainColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.8346 12.8307L11.668 11.6641" [attr.stroke]="!isHeaderBreakpoint ? defaultBurgerColor : customConfig.mainColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            }@else{
                <div class="search-icon-btn" (click)="onSearchClick()">
                    <img [src]="isHeaderBreakpoint ? 'assets/images/search-blue.svg' : 'assets/images/search-white.svg'" alt="">
                </div>
            }
        }
    </div>
    @if (products.length > 0 || showNoRecords) {
        <div class="search-border"></div>
    }
    <div class="search-results-container" [class.show]="products.length > 0 || isClosingSearch || showNoRecords"
        [@slideDownAnimation]="searchAnimationState">
        <div class="search-results thin-v-scrollbar" [appPreventParentScroll]="products.length > 0 || isClosingSearch || showNoRecords">
            @if (products.length === 0 && showNoRecords) {
                <div class="no-records px-15" [style.animation-delay]="(i * 100) + 'ms'">
                    {{'general.no-records' | translate}}
                </div>
            }
            @if (products.length > 0) {
                @for (product of products; track product; let i = $index) {
                    <div class="results-item" [style.animation-delay]="((i % searchBarPage.size + 1) * 100) + 'ms'" (click)="showProductDetails(product)">
                        @if(product?.image){
                            <img [src]="product?.image" class="item-img" imageLoader thumbnailSize="S">
                        }
                        <div class="ticketing-type-container">
                            <div class="ticketing-type-content">
                                <div class="ticketing-type-text">
                                    {{ (product.objectType === 'EVENT' ? 'seo_information.event' : 'seo_information.subscription') | translate }}
                                </div>
                            </div>
                        </div>
                        <div class="results-item-details">
                            <div class="item-title">{{product.title}}</div>
                            @if (product.objectType === 'EVENT' || (product.subscriptionType === 'F' && product.siae)) {
                                <div class="d-flex align-items-center  fw-400" [ngClass]="isHeaderBreakpoint ? 'fz-10' : 'fz-12'">
                                    <i class="ti-location-pin mr-5"></i>
                                  <span>{{ product.place }}{{ product.address && product.place ? ', ' : null}}{{ product.address }}</span>
                                </div>
                            }
                            @if (product.startDateTime && product.objectType === 'EVENT') {
                                <div class="d-flex">
                                    <div class="item-date">
                                        <i class="ti-calendar mr-5" [ngClass]="isHeaderBreakpoint ? 'fz-8' : 'fz-12'"></i>
                                        <span class="text-capitalize" [ngClass]="isHeaderBreakpoint ? 'fz-10' : 'fz-12'">
                                            {{(product.startDateTime) | localizedDate}}
                                        </span>
                                    </div>
                                    <div class="d-flex align-items-center fw-400">
                                        <i class="ti-time mr-5" [ngClass]="isHeaderBreakpoint ? 'fz-8' : 'fz-12'"></i>
                                        <span [ngClass]="isHeaderBreakpoint ? 'fz-10' : 'fz-12'">
                                            {{(product.startDateTime) | localizedDate:'HH:mm'}}
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
                @if (!loadedAllSearchItems) {
                    <div class="d-flex justify-content-end my-10">
                        <button class="btn search-btn-blue btn-h-26 fw-600" (click)="onLoadNextPage()" [disabled]="isLoadingSearchItems">
                            @if (!isLoadingSearchItems) {
                                {{'general.load_more' | translate}}
                            } @else {
                                <div class="loader-inline" style="transform: scale(0.5);"></div>
                            }       
                        </button>
                    </div>
                }
            }
        </div>
    </div>
</div>
